import { FieldNode, FieldNodeType } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

export type RenderableSignerFieldNodeType = Extract<
  FieldNodeType,
  'TEXT' | 'SIGNATURE' | 'CHECKBOX_GROUP' | 'DROPDOWN' | 'DATE' | 'SIGNING_DATE' | 'AUTOFILL_GROUP'
>;

export type RenderableSignerFieldNode = Extract<FieldNode, { type: RenderableSignerFieldNodeType }>;

export function isRenderableSignerFieldNode(
  node: DeepReadonly<FieldNode>
): node is DeepReadonly<RenderableSignerFieldNode> {
  if (node.participantReference.type !== 'SIGNER') {
    return false;
  }
  switch (node.type) {
    case 'SIGNATURE':
    case 'CHECKBOX_GROUP':
    case 'AUTOFILL_GROUP':
    case 'TEXT':
    case 'DROPDOWN':
    case 'DATE':
    case 'SIGNING_DATE':
      return true;
    default:
      return false;
  }
}

export type RequesterFieldNodeType = Extract<FieldNodeType, 'TEXT' | 'CHECKBOX' | 'IMAGE'>;

export type RequesterFieldNode = Extract<FieldNode, { type: RequesterFieldNodeType }>;

export function isRequesterFieldNode(
  node: DeepReadonly<FieldNode>
): node is DeepReadonly<RequesterFieldNode> {
  if (node.participantReference.type !== 'REQUESTER') {
    return false;
  }

  switch (node.type) {
    case 'TEXT':
    case 'CHECKBOX':
    case 'IMAGE':
      return true;
    default:
      return false;
  }
}
